import { render, staticRenderFns } from "./redemptionList.vue?vue&type=template&id=5f93b56a&scoped=true"
import script from "./redemptionList.vue?vue&type=script&lang=js"
export * from "./redemptionList.vue?vue&type=script&lang=js"
import style0 from "./redemptionList.vue?vue&type=style&index=0&id=5f93b56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f93b56a",
  null
  
)

export default component.exports